<template>
  <div class="l-content-inner">
    <!-- 회원가입 -->
    <div class="p-member-wrap">
      <div class="c-hgroup is-pc">
        <h1 class="c-title-level1">노루페인트 PAINT PRO 아이디 찾기</h1>
      </div>

      <form action="">
        <div class="form-wrap type-large-gap">
          <div class="c-form-field">
            <label
              class="c-input-label-group"
              :class="{ 'is-danger': isNvl('busiNo') }"
            >
              <input
                type="text"
                required
                title="사업자 등록번호"
                maxlength="12"
                v-model="form.busiNo"
                @keyup="() => (touched.busiNo = true)"
                @blur="() => (touched.busiNo = true)"
                @change="custIdSearch"
              />
              <span class="input-label">사업자 등록번호</span>
              <span v-show="isEmpty('busiNo')" class="input-helper">
                사업자 등록번호를 입력해주세요.
              </span>
            </label>
          </div>

          <div class="c-form-field">
            <label
              class="c-input-label-group"
              :class="{ 'is-danger': isNvl('custNm') }"
            >
              <input
                type="text"
                required
                title="특약점명"
                maxlength="50"
                v-model="form.custNm"
                @keyup="() => (touched.custNm = true)"
                @blur="() => (touched.custNm = true)"
              />
              <span class="input-label">특약점명</span>
              <span v-show="isEmpty('custNm')" class="input-helper">
                특약점명을 입력해주세요.
              </span>
            </label>
          </div>

          <div class="c-form-field">
            <label
              class="c-input-label-group"
              :class="{ 'is-danger': isNvl('repreNm') }"
            >
              <input
                type="text"
                required
                title="대표자명"
                maxlength="10"
                v-model="form.repreNm"
                @keyup="() => (touched.repreNm = true)"
                @blur="() => (touched.repreNm = true)"
              />
              <span class="input-label">대표자명</span>
              <span v-show="isEmpty('repreNm')" class="input-helper">
                대표자명을 입력해주세요.
              </span>
            </label>
          </div>
        </div>

        <div class="c-btn-area">
          <button
            type="button"
            class="c-button type-primary"
            :disabled="submitDisabledYn"
            @click.prevent="submit"
          >
            <span>확인</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>
<script setup>
import { onMounted, defineEmits, ref, computed, inject } from "vue";
import { api } from "@/plugins/api";
import Utils from "@/js/utils";
import * as cmUtil from "@/utils/cmUtil";

const emits = defineEmits(["next"]);
const url = inject("url_prefix");

const custIdSearch = async() => {
  
  if(isEmpty("busiNo")){return;}

  const payload = {
    busiNo: form.value.busiNo
  };

  const res = await api.post(`${url}/register/id-name-search`, payload);

  if (res.error) {
    if (res.error.status === "404") {
      form.value.custNm = "";
      cmUtil.alert(
        "입력하신 정보가 확인되지 않습니다. 담당 영업사원에게 문의해주세요."
      );
    } else {
      cmUtil.alert("오류가 발생하였습니다. <br/>문의: 담당 영업사원");
    }
    return;
  }

  form.value.custNm = res.data.zbpName;
  touched.value.custNm = true;
};

const form = ref({
  busiNo: "", // 사업자번호
  custNm: "", // 특약점명
  repreNm: "", // 대표자명
});

const touched = ref({
  busiNo: false, // 사업자번호
  custNm: false, // 특약점명
  repreNm: false, // 대표자명
});

onMounted(() => {});

const submitDisabledYn = computed(() => {
  return (
    !touched.value.busiNo ||
    !touched.value.custNm ||
    !touched.value.repreNm ||
    isNvl("busiNo") ||
    isNvl("custNm") ||
    isNvl("repreNm")
  );
});

const isNvl = (field) => {
  return touched.value[field] && isInvalid(field);
};

const isInvalid = (field) => {
  return Utils.isBlank(form.value[field]);
};

const isEmpty = (field) => {
  return touched.value[field] && Utils.isBlank(form.value[field]);
};

const submit = async () => {
  const payload = {
    busiNo: form.value.busiNo,
    custNm: form.value.custNm,
    repreNm: form.value.repreNm,
  };

  const res = await api.post(`${url}/register/id-search`, payload);

  // if (res.resultCode !== 200) {
  //   cmUtil.alert(res.message);
  //   return;
  // }

  if (res.error) {
    if (res.error.status === "404") {
      cmUtil.alert(
        "입력하신 정보가 확인되지 않습니다. <br/>담당 영업사원에게 문의해주세요"
      );
    } else {
      cmUtil.alert("오류가 발생하였습니다. <br/>문의: 담당 영업사원");
    }

    return;
  }
  emits("next", res.data);
};
</script>
